import { el, escape } from './dom';
import { BLOG_POSTS } from '../blog/posts';

const formatDate = (iso: string): string => {
  const d = new Date(`${iso}T00:00:00Z`);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC',
  });
};

export type BlogIndexProps = {
  heroH1: string;
  heroLede: string;
};

export const BlogIndex = (props: BlogIndexProps): HTMLElement => {
  const items = [...BLOG_POSTS]
    .sort((a, b) => (a.publishedOn < b.publishedOn ? 1 : -1))
    .map(
      (p) => `
        <li class="blog-index-item">
          <a class="blog-index-link" href="/blog/${escape(p.slug)}">
            <div class="blog-meta mono">
              <time datetime="${escape(p.publishedOn)}">${escape(formatDate(p.publishedOn))}</time>
              <span class="dot">·</span>
              <span>${escape(p.readingTime)}</span>
            </div>
            <h3>${escape(p.title)}</h3>
            <p>${escape(p.description)}</p>
          </a>
        </li>`,
    )
    .join('');

  return el(`
    <section class="blog-index">
      <div class="container">
        <header class="blog-index-header">
          <h1>${escape(props.heroH1)}</h1>
          <p class="blog-lede">${escape(props.heroLede)}</p>
        </header>
        <ul class="blog-index-list">${items}</ul>
      </div>
    </section>
  `);
};
